export default function getLocation (successCallback, errorCallback, geolocationNotSupportedCallback) {
  const geolocationOptions = {
    enableHighAccuracy: true,
    maximumAge: 10000,
    timeout: 5000
  }
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback, geolocationOptions)
  } else {
    geolocationNotSupportedCallback()
  }
}
